<template>
  <div id="el-mail-cont">
    <div class="el-tuis-cons">
      <div class="tit-rit">信息推送</div>
      <div class="el-date-cons">
        <div class="el-sel-times">
          <el-divider content-position="left">请选择推送方式：</el-divider>
          <el-radio-group v-model="radio">
            <el-radio :label="0" @change="raDitZero">不推送</el-radio>
            <el-radio :label="1" @change="raDitone">每日推送</el-radio>
            <el-radio :label="2" @change="raDittwo">定时推送</el-radio>
          </el-radio-group>
        </div>
        <div class="el-li-time" :style="disabled">
          <!-- <el-divider content-position="left">每日推送</el-divider> -->
          <div class="block">
            <span class="demonstration">请选择推送时间：</span>
            <el-select
              v-model="dateValueDay"
              multiple
              placeholder="请选择"
              :style="{ width: selWidth }">
              <el-option
                v-for="item in dateValueList"
                :key="item.id"
                :label="item.daytime"
                :value="item.daytime">
              </el-option>
            </el-select>
            <el-button class="el-lin-but" type="primary" @click="tuiEmailTwo">推送</el-button>
            <div class="el-bz-mail">
              <span>（*注：每日推送时间节点可多选）</span>
            </div>
          </div>
        </div>
        <div class="el-li-time" :style="sdisabled">
          <!-- <el-divider content-position="left">定时推送</el-divider> -->
          <div class="block">
            <span class="demonstration">请选择推送日期：</span>
            <el-date-picker
              v-model="dateValueOne"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <el-button class="el-lin-but" type="primary" @click="timedPush"
              >推送</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Pushemail",
  data() {
    return {
      radio: 1,
      disabled: { display: "none" },
      sdisabled: { display: "none" },
      dataNum1: 2,
      dataNum2: 3,
      dateValueOne: "",
      dateValueDay: "",
      selWidth: "350px",
      dateValueList: [
        {
          id: 1,
          daytime: "--:--:--",
        },
      ],
    };
  },
  created() {
    // this.getEmail();
  },
  mounted() {
    // this.radDits();
    // this.getcTimes();
  },
  methods: {
    //选中单选按钮时时另一个推送禁止选择
    radDits() {
      //默认选中第一个时的操作
      if (this.radio == 1) {
        this.disabled = { display: "block" };
        this.sdisabled = { display: "none" };
      }
    },
    //默认0发送
    raDitZero() {
      this.disabled = { display: "none" };
      this.sdisabled = { display: "none" };
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("SendMail/setSendMail", {
          token: tokens,
          sendWay: 0,
        })
        .then((res) => {
          this.$message({
            message: "设置成功", //弹出返回信息
            type: "success",
            offset: 150,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //选中第一个
    raDitone() {
      this.disabled = { display: "block" };
      this.sdisabled = { display: "none" };
    },
    //选中第二个
    raDittwo() {
      this.disabled = { display: "none" };
      this.sdisabled = { display: "block" };
    },
    //定时推送--推送时间数据
    timedPush() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("SendMail/setSendMail", {
          token: tokens,
          sendWay: 2,
          bcc: null,
          datetime: this.dateValueOne, //推送的日期
        })
        .then((res) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            type: "success",
            offset: 150,
          });
        })
        .catch((err) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            type: "warning",
            offset: 150,
          });
        });
    },
    //每日推送--获取全天发送时间段
    getEmail() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("SendMail/dayTimes", {
          token: tokens,
        })
        .then((res) => {
          let dataId = [];
          let dataDaytime = [];
          res.data.data.forEach((item, index, arr) => {
            let itemId = item.id;
            let itemTime = item.daytime;
            dataId.push(itemId);
            dataDaytime.push(itemTime);
          });
          this.dateValueList = dataId.map((item, index) => {
            return {
              id: item,
              daytime: dataDaytime[index],
            };
          });
        })
        .catch((err) => {
          console.log("服务器错误，暂无数据");
        });
    },
    //每日推送--发送数据
    tuiEmailTwo() {
      let tokens = localStorage.getItem("token");
      let a = this.dateValueDay;
      let s = a.toString();
      this.$axios
        .post("SendMail/setSendMail", {
          token: tokens,
          sendWay: 3,
          bcc: null,
          //推送的时间（格式为字符串）
          daytime: s,
        })
        .then((res) => {
          this.$message({
            //弹出返回信息
            message: res.data.msg,
            type: "success",
            offset: 150,
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            //弹出返回信息
            message: res.data.msg,
            type: "warning",
            offset: 150,
          });
        });
    },
    //获取已经选中的时间--未完成
    getcTimes() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("SendMail/index", {
          token: tokens,
        })
        .then((res) => {
          // console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
@import "./coms/user.css";
</style>



// WEBPACK FOOTER //
// src/components/user/mail_tui.vue